import React from "react";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle navigation</span>
            <i className="fa fa-bars navbar-toggle-icon"></i>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img
              src="img/Logo_Thermix/Logo_white.png"
              alt="Priori Logo"
              className="navbar-logo"
            />
            Priori
          </a>
           {/* Place the button here so it's always visible */}
          <a href="/platform" className="nav-cta-btn nav-btn-mobile">
            Try Priori
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right-end">
            <li>
              <a href="#announcement" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
            <li className="nav-btn nav-btn-desktop">
              <a href="/platform" className="nav-cta-btn">
                Try Priori
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};